module.exports = __webpack_public_path__ + "img/stars-white.da488c5b.png";